import { render, staticRenderFns } from "./detail_agence.vue?vue&type=template&id=2a4e848e"
import script from "./detail_agence.vue?vue&type=script&lang=js"
export * from "./detail_agence.vue?vue&type=script&lang=js"
import style0 from "./detail_agence.vue?vue&type=style&index=0&id=2a4e848e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports